function isPasswordMatch(password, confirmPassword) {
  return password === confirmPassword;
}

export default isPasswordMatch;
